
import React from 'react';

import ObjectDetailAttributeHover from './ObjectDetailAttributeHover';
import ObjectDetailAttributeLink from './ObjectDetailAttributeLink';
import ObjectDetailAttributeText from './ObjectDetailAttributeText';

import { Log } from '../../../core';
const log = Log.getLogger('MultiSceneForApp.data.components.objectDetail.ObjectDetailAttribute');

const ObjectDetailAttribute = ({attribute, dataModel, value}) => {

    const visualizeType = (attribute.visualize)
        ? attribute.visualize.type
        : 'text';

    let attributeComponent;

    if (attribute.hidden !== true) {
        switch (visualizeType) {
            case 'hover':
                attributeComponent = ObjectDetailAttributeHover;
                break;
            case 'link':
                attributeComponent = ObjectDetailAttributeLink;
                break;
            case 'text':
                attributeComponent = ObjectDetailAttributeText;
                break;
            default:
                log.warn(`unknown visualize type: ${visualizeType}`);
                attributeComponent = ObjectDetailAttributeText;
        }
    }

    if (value && attributeComponent) {
        return React.createElement(
            attributeComponent, {attribute, dataModel, value}
        );
    } else {
        return null;
    }
}

export default ObjectDetailAttribute;
